import { format } from 'date-fns'
import type { Filters } from 'hooks/store/restricted-products/use-restriction-event-search-params';
import type { FormSchema } from './form-schema';

const d = (date: Date) => format(date, 'yyyy-MM-dd')

export const createFilterParams = (formData: FormSchema): Filters => {
  const { createdAt, ...rest } = formData;

  return {
    ...rest,
    ...(createdAt?.from && { createdAtFrom: d(createdAt.from) }),
    ...(createdAt?.to && { createdAtTo: d(createdAt.to) })
  }
};